import { useFormikContext } from 'formik'
import { Button, FormControl, FormHelperText, Input, InputLabel, Typography } from '@mui/material'

import { useStyles } from './styles'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { handleTrimValueOnPaste } from 'src/common/handlers'

const ChangePasswordVerificationForm = () => {
  const { errors, values, handleChange, isSubmitting, setFieldValue } = useFormikContext<{
    code: string
  }>()
  const classes = useStyles()

  return (
    <div className={classes.formWrapper}>
      <div className={classes.formInputsWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="password-change-form-title" ns={ETranslationNs.UserProfile} />
        </Typography>
        <FormControl>
          <InputLabel htmlFor="code">
            <HelperWrapper t="verification-code-input-label" ns={ETranslationNs.Form} />*
          </InputLabel>
          <Input
            autoComplete="off"
            value={values.code}
            onChange={handleChange}
            name="code"
            id="code"
            type={'text'}
            onPaste={(event) => handleTrimValueOnPaste(event, values.code, setFieldValue, 'code')}
          />
          <FormHelperText>
            <Typography className={classes.warningText}>
              {errors.code && <HelperWrapper t={errors.code} />}
            </Typography>{' '}
          </FormHelperText>
        </FormControl>
      </div>
      <Button disabled={isSubmitting} variant="contained" type="submit">
        <HelperWrapper t="password-change-submit-button-1" ns={ETranslationNs.UserProfile} />
      </Button>
    </div>
  )
}

export { ChangePasswordVerificationForm }
